<form [formGroup]="clientForm">
    <div class="bg-blue-2 d-flex al-center sp-between p-4">
      <div>
        <div>
          <span class="text-white fw-extrabold fs-4">Nuevo {{ rol == 1 ? 'asesor': 'cliente'}}</span>
        </div>
        <div>
          <span class="text-white fs-6 fw-regular">Crea nuevo {{ rol == 1 ? 'asesor': 'cliente'}}</span>
        </div>
      </div>
      <div>
        <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
      </div>
    </div>
    <mat-dialog-content class="p-5 d-flex flex-column content-form">
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Nombres y apellidos (Obligatorio)</span>
        </div>
        <input nz-input formControlName="fullname" placeholder="Ingrese nombres y apellidos del cliente" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">País (Obligatorio)</span>
        </div>
        <nz-select class="w-100" formControlName="country" nzPlaceHolder="Busque país de residencia">
          <nz-option [nzValue]="c.id" [nzLabel]="c.descripcion" class="fs-6" *ngFor="let c of countries"></nz-option>
        </nz-select>
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Ciudad</span>
        </div>
        <input nz-input formControlName="city" placeholder="Ingrese ciudad de residencia" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Dirección</span>
        </div>
        <input nz-input formControlName="address" placeholder="Ingrese dirección de residencia" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Número telefónico</span>
        </div>
        <input nz-input formControlName="phone" maxlength="13" (keypress)="keypressNumbers($event)" placeholder="Número telefónico" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Correo electrónico</span>
        </div>
        <input nz-input formControlName="email" placeholder="Ingrese correo electrónico" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Fecha de nacimiento</span>
        </div>
        <input nz-input formControlName="fecnac" placeholder="dd/mm/aaaa" maxlength="10" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Número de hijos</span>
        </div>
        <input nz-input formControlName="numHijos" placeholder="Ingrese la cantidad de hijos del cliente" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Empresa donde labora</span>
        </div>
        <input nz-input formControlName="enterprise" placeholder="Ingrese nombre de empresa" class="w-100" />
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Ingresos anuales</span>
        </div>
        <nz-select class="w-100" formControlName="salary" nzPlaceHolder="Ingresos anuales aproximados en USD">
          <nz-option [nzValue]="s.id" [nzLabel]="s.descripcion" *ngFor="let s of salaries"></nz-option>
        </nz-select>
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Tamaño de patrimonio</span>
        </div>
        <nz-select class="w-100" formControlName="heritage" nzPlaceHolder="Ingrese el tamaño de patrimonio del cliente">
          <nz-option [nzValue]="h.id" [nzLabel]="h.descripcion" *ngFor="let h of heritages"></nz-option>
        </nz-select>
      </div>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Tipo de ingresos</span>
        </div>
        <div class="row">
            <div class="col-sm-6" *ngFor="let in of incomes">
                <label nz-checkbox [ngModel]="in.checked" [ngModelOptions]="{standalone: true}" (ngModelChange)="in.checked = !in.checked">{{in.descripcion}}</label>
            </div>
        </div>
      </div>
    </mat-dialog-content>
    <div class="p-4 text-end content-action">
      <mat-dialog-actions align="end">
        <button mat-flat-button al class="bg-blue-2" (click)="saveClient()" [disabled]="clientForm.invalid">
          <span class="fw-bold fs-5 text-white me-3">Guardar {{ rol == 1 ? 'asesor': 'cliente'}}</span>
          <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
        </button>
      </mat-dialog-actions>
    </div>
  </form>
  <ng-container *ngIf="loader">
    <app-loader></app-loader>
  </ng-container>